import { Component, Inject, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { NgxFlickingComponent, Plugin } from "@egjs/ngx-flicking";
import { Sync } from "@egjs/flicking-plugins";
import { TranslocoService } from '@ngneat/transloco';
import { ImportService } from '../../services';
import { Id, ISceneTemplate } from './../../interfaces/scenes-interfaces';
import { Compbaser } from "../compbaser/compbases";
import { DialogImportingComponent } from '../dialog-importing/dialog-importing.component';

interface IDialogImportScene {
    showDownloadingCancel?: boolean;
    template: ISceneTemplate;
    routerAfterImport?: boolean;
}

@Component({
    selector: 'app-dialog-import-scene',
    templateUrl: './dialog-import-scene.component.html',
    styleUrls: ['./dialog-import-scene.component.scss']
})
export class DialogImportSceneComponent extends Compbaser implements OnInit, AfterViewInit {
    @ViewChild("flicking0", { static: false }) flicking0: NgxFlickingComponent;
    @ViewChild("flicking1", { static: false }) flicking1: NgxFlickingComponent;

    public thumbPlugins: Plugin[] = [];

    showDownloadingCancel = false;
    routerAfterImport = false;
    sceneTemplate: ISceneTemplate;
    imageLoading = true;
    downloadingDialog;

    constructor(
        private translocoService: TranslocoService,
        private toastr: ToastrService,
        private router: Router,
        private importService: ImportService,
        protected override dialog: MatDialog,
        public dialogRef: MatDialogRef<any>, 
        @Inject(MAT_DIALOG_DATA) public data: IDialogImportScene
    ) {
        super();
        this.imageLoading = true;
        this.showDownloadingCancel = !!data.showDownloadingCancel;
        this.routerAfterImport = !!data.routerAfterImport;
        this.sceneTemplate = data.template;
        if (!this.sceneTemplate) {
            this.dialogRef.close();
        }
    }

    ngOnInit(): void {
    }

    ngAfterViewInit(): void {
        setTimeout(() => {
            this.thumbPlugins = [new Sync({
                type: "index",
                synchronizedFlickingOptions: [
                    {
                        flicking: this.flicking0,
                        isSlidable: true
                    },
                    {
                        flicking: this.flicking1,
                        isClickable: true,
                        activeClass: "active"
                    }
                ]
            })]
        }, 333);
    }

    onLoad() {
        this.imageLoading = false;
    }

    /** Click event: create scene button */
    async onClickImport(selectedScene: ISceneTemplate) {

        this.downloadingDialog = this.dialog.open(DialogImportingComponent, {
            height: '400px',
            width: '400px',
            panelClass: 'transparentDialog',
            data: {
                showCancel: this.showDownloadingCancel,
                showProgress: true
            },
            disableClose: true
        });
        try {
            const newPlayerId = await this.importService.importScene(selectedScene.businessId, selectedScene.sceneId, selectedScene.sceneTitle, null, true);
            if (!newPlayerId) {
                this.downloadingDialog.close();
                this.toastr.error(this.translocoService.translate('toast.failedCreateScene', {}, this.translocoService.getActiveLang()));
                return;
            }
            this.onCreatedScene(newPlayerId);
        } catch (err) {
            console.log(err);
            setTimeout(() => {
                this.downloadingDialog.close();
            }, 1200);
        }
    }

    /** Handle event after created scene */
    onCreatedScene(sceneId: Id) {
        if (!sceneId) {
            this.toastr.error(this.translocoService.translate('toast.failedCreateScene', {}, this.translocoService.getActiveLang()));
            return;
        }
        this.toastr.info(this.translocoService.translate('toast.createSceneId', {}, this.translocoService.getActiveLang()) + ' ' + sceneId);
        this.closeModal(sceneId);

        if (this.routerAfterImport) {
            this.router.navigateByUrl(`editor/scene/${sceneId}`);
        }
    }

    closeModal(sceneId = null) {
        if (this.dialogRef) {
            this.dialogRef.close(sceneId);
        }
        if (this.downloadingDialog) {
            this.downloadingDialog.close();
        }
    }

    closeImporting() {
        this.dialogRef.close();
    }
}


